import { render, staticRenderFns } from "./InvoiceTasks.vue?vue&type=template&id=05109bd2&scoped=true&"
import script from "./InvoiceTasks.vue?vue&type=script&lang=js&"
export * from "./InvoiceTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05109bd2",
  null
  
)

export default component.exports